var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_vm._t("default"):_c('div',{staticClass:"d-flex justify-center align-center",style:(`width: 100%;`)},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"green"}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }